export default __webpack_public_path__ + "static/media/mapview.923cf11d.gif";